module.exports = __webpack_public_path__ + "static/media/community.631e901a.png";